import { request } from "./client";

export interface AgentBackend {
  id: string;
  display_name: string;
  endpoint: string;
  slug: string;
  api_key: string;
  voice_id: string;
  created_at: number;
  updated_at: number;
}

export function listAgentBackends(): Promise<AgentBackend[]> {
  return request("/agent-backends");
}

export function getAgentBackend(id: string): Promise<AgentBackend> {
  return request(`/agent-backends/${id}`);
}

export function createAgentBackend(data: { id: string; display_name: string; endpoint: string; slug: string; api_key?: string; voice_id?: string }): Promise<{ id: string }> {
  return request("/agent-backends", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export function updateAgentBackendVoice(id: string, voiceId: string): Promise<{ id: string; voice_id: string }> {
  return request(`/agent-backends/${id}/voice`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ voice_id: voiceId }),
  });
}

export function deleteAgentBackend(id: string): Promise<{ id: string }> {
  return request(`/agent-backends/${id}`, { method: "DELETE" });
}
